const reviews = [
  {
    id: 1,
    name: 'susan smith',
    job: 'After 2 Year',
    image:
      'https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883334/person-1_rfzshl.jpg',
    text:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum facilis exercitationem delectus assumenda sed quis et laudantium repudiandae velit, ad porro esse obcaecati voluptatum consequatur voluptatem aspernatur amet dolorem nobis?",
  },
  {
    id: 2,
    name: 'anna johnson',
    job: 'After 1 year',
    image:
      'https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883409/person-2_np9x5l.jpg',
    text:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum facilis exercitationem delectus assumenda sed quis et laudantium repudiandae velit, ad porro esse obcaecati voluptatum consequatur voluptatem aspernatur amet dolorem nobis?',
  },
  {
    id: 3,
    name: 'peter jones',
    job: 'After 5 year',
    image:
      'https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883417/person-3_ipa0mj.jpg',
    text:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum facilis exercitationem delectus assumenda sed quis et laudantium repudiandae velit, ad porro esse obcaecati voluptatum consequatur voluptatem aspernatur amet dolorem nobis?',
  },
  {
    id: 4,
    name: 'bill anderson',
    job: 'After a week',
    image:
      'https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883423/person-4_t9nxjt.jpg',
    text:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum facilis exercitationem delectus assumenda sed quis et laudantium repudiandae velit, ad porro esse obcaecati voluptatum consequatur voluptatem aspernatur amet dolorem nobis? ',
  },
];

export default reviews;
